import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { useStore } from '@/store';
import { NotificationItem } from './NotificationItem';

export function ToastContainer() {
  const notifications = useStore((state) => state.notifications);
  const removeNotification = useStore((state) => state.removeNotification);

  // Create container element
  useEffect(() => {
    const container = document.getElementById('toast-container');
    if (!container) {
      const div = document.createElement('div');
      div.id = 'toast-container';
      document.body.appendChild(div);
    }
  }, []);

  if (notifications.length === 0) return null;

  const content = (
    <div
      className="pointer-events-none fixed right-4 bottom-4 z-50"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="pointer-events-auto flex w-full max-w-sm flex-col gap-3">
        <AnimatePresence mode="sync">
          {notifications.map((notification) => (
            <motion.div
              key={notification.id}
              initial={{ opacity: 0, y: 20, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, x: 100, scale: 0.95 }}
              transition={{
                duration: 0.2,
                ease: 'easeOut',
              }}
              layout
            >
              <NotificationItem notification={notification} onDismiss={removeNotification} />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );

  const container = document.getElementById('toast-container');
  return container ? createPortal(content, container) : content;
}

// Alternative version without framer-motion for lighter bundle
export function ToastContainerLite() {
  const notifications = useStore((state) => state.notifications);
  const removeNotification = useStore((state) => state.removeNotification);

  if (notifications.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed right-4 bottom-4 z-50"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="pointer-events-auto flex w-full max-w-sm flex-col gap-3">
        {notifications.map((notification) => (
          <div
            key={notification.id}
            className="animate-in slide-in-from-bottom fade-in duration-200"
          >
            <NotificationItem notification={notification} onDismiss={removeNotification} />
          </div>
        ))}
      </div>
    </div>
  );
}
